import {readAddress} from './address.serializer';

import Location from '../models/location.model';

/**
 * Read a location retrieved from the backend.
 * @param {Object} o
 * @return {Location}
 */
function readLocation(o) {
  const address = readAddress(o, true).makeImmutable();

  return new Location(
    o.id,
    o.is_default,
    o.name,
    o.short_name,
    o.email,
    o.phone,
    address,
    o.area,
    o.open_hours,
    o.route_description,
    o.parking_info,
    o.payment_options,
    o.services,
    o.other_services,
    o.general_info,
    o.place_id,
    o.url,
    o.city,
    o.image,
  );
}

export {
  readLocation
};



// WEBPACK FOOTER //
// ./src/app/common/serializers/location.serializer.js